import * as React from 'react';

import { DropdownField, IDropdownValue } from '../../../components/dropdownField';

export interface IDwellingStatusProps {
  withApartment: boolean | undefined;
  onApartmentChanged(value?: boolean): void;
}

enum EWithApartament {
  Any,
  With,
  Without,
}

const OPTIONS: IDropdownValue[] = [
  { value: EWithApartament.Any, label: 'Неважно' },
  { value: EWithApartament.Without, label: 'Без апартаментов' },
  { value: EWithApartament.With, label: 'Только апартаменты' },
];

export class DwellingStatus extends React.Component<IDwellingStatusProps> {
  public render() {
    return <DropdownField value={this.getValue()} onValueChange={this.handleChange} values={OPTIONS} />;
  }

  private handleChange = (value: EWithApartament) => {
    if (value === EWithApartament.Any) {
      return this.props.onApartmentChanged();
    }

    return this.props.onApartmentChanged(value === EWithApartament.With);
  };

  private getValue() {
    switch (this.props.withApartment) {
      case true:
        return EWithApartament.With;
      case false:
        return EWithApartament.Without;
      default:
        return EWithApartament.Any;
    }
  }
}
